import React from 'react';
// import { Link } from 'react-router-dom';
import './Products.css';

const Products = () => {
  return (
    <div className="products-page">
      <div className="container">
        <div className="page-header">
          <h1>Our Products</h1>
          <p>Discover our comprehensive suite of business solutions designed to help your organization achieve sustainable success and measurable results.</p>
        </div>

        <div className="products-grid">
          <div className="product-card">
            <div className="product-icon">
              <span>🛒</span>
            </div>
            <h2>EPOS - Point of Sale Software</h2>
            <p className="product-subtitle">Complete Restaurant & Cafe Management Solution</p>
            <div className="product-description">
              <p>Our comprehensive EPOS solution is designed specifically for restaurants and cafes, providing seamless transaction management, inventory tracking, and customer relationship management.</p>
            </div>
            <div className="product-features">
              <h3>Key Features:</h3>
              <ul>
                <li>Transaction management and processing</li>
                <li>Real-time inventory tracking</li>
                <li>Customer relationship management</li>
                <li>Sales reporting and analytics</li>
                <li>Multi-location support</li>
                <li>Staff management and permissions</li>
              </ul>
            </div>
            <div className="product-cta">
              <a href="/contact" className="btn btn-primary">Get Started</a>
              <a href="/contact" className="btn btn-outline">Learn More</a>
            </div>
          </div>

          <div className="product-card">
            <div className="product-icon">
              <span>💬</span>
            </div>
            <h2>WhatsApp Business Platform</h2>
            <p className="product-subtitle">Complete Business Messaging Solution</p>
            <div className="product-description">
              <p>WhatsApp Business messaging platform that enables businesses to manage customer conversations, send broadcast campaigns, and provide customer support through WhatsApp. The application serves as a complete business messaging solution with both automated bot responses and human agent handover capabilities.</p>
            </div>
            <div className="product-features">
              <h3>Key Features:</h3>
              <ul>
                <li>Customer conversation management</li>
                <li>Broadcast campaigns and marketing</li>
                <li>Automated bot responses</li>
                <li>Human agent handover capabilities</li>
                <li>Customer support integration</li>
                <li>Analytics and reporting</li>
                <li>Multi-agent support</li>
                <li>Template message management</li>
              </ul>
            </div>
            {/* <div className="product-cta">
              <Link to="/whatsapp-signup" className="btn btn-primary">Get Started</Link>
              <a href="/contact" className="btn btn-outline">Learn More</a>
            </div> */}
          </div>
        </div>

        <div className="products-cta">
          <h2>Ready to Transform Your Business?</h2>
          <p>Let our experienced consultants help you choose the right products for your organization's needs.</p>
          <a href="/contact" className="btn btn-primary">Contact Us Today</a>
        </div>
      </div>
    </div>
  );
};

export default Products;
